import React from 'react';

interface AnimatedCheckboxProps {
  checked: boolean;
  size?: 'sm' | 'md';
}

export function AnimatedCheckbox({ checked, size = 'md' }: AnimatedCheckboxProps) {
  const dimension = size === 'sm' ? 24 : 32;
  
  return (
    <div 
      className="relative inline-block"
      style={{ width: dimension, height: dimension }}
    >
      <svg viewBox="0 0 35.6 35.6" className="w-full h-full">
        <circle 
          className="transition-all duration-500"
          cx="17.8" 
          cy="17.8" 
          r="17.8" 
          fill={checked ? '#2a36e2' : '#d1d5db'}
        />
        <circle 
          className="transition-all duration-500"
          cx="17.8" 
          cy="17.8" 
          r="14.37" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeDasharray="100"
          strokeDashoffset={checked ? 0 : 100}
        />
        <polyline 
          className="transition-all duration-500"
          points="11.78 18.12 15.55 22.23 25.17 12.87" 
          fill="none" 
          stroke="#fff" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2"
          strokeDasharray="22"
          strokeDashoffset={checked ? 0 : 22}
        />
      </svg>
    </div>
  );
}
